<style>
  svg {
    display: block;
  }
</style>

<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 25.3 24.9"
  style="enable-background:new 0 0 25.3 24.9;"
  xml:space="preserve">
  <polygon
    points="21.7,1.6 12.7,10.7 3.6,1.6 1.8,3.4 10.8,12.4 1.8,21.5 3.6,23.3
    12.7,14.3 21.7,23.3 23.5,21.5 14.4,12.4 23.5,3.4 " />
</svg>
